import React from 'react';
import styled, { keyframes } from 'styled-components';
import ChevronDown from '@panel/commons/assets/icons/ChevronDown.svg';
import ChevronUp from '@panel/commons/assets/icons/ChevronUp.svg';

const DropDown = ({ title, isOpen, setIsOpen, children }) => {
  return (
    <Container>
      <Header>
        <Title data-panel='panel-avisos-dropdown-qualityTitle'>{title}</Title>
        <Chevron onClick={() => setIsOpen(!isOpen)} isOpen={isOpen} data-panel='panel-avisos-dropdown-qualityChevron' />
      </Header>
      <ContentArea isOpen={isOpen}>{children}</ContentArea>
    </Container>
  );
};

export default DropDown;

const Container = styled.div`
  width: 100%;
  height: fit-content;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
`;

const Chevron = styled.button`
  background-image: ${({ isOpen }) => `url(${isOpen ? ChevronUp : ChevronDown})`};
  width: 24px;
  height: 24px;
  background-size: cover;
  background-repeat: no-repeat;
  cursor: pointer;
  margin-right: 8px;
`;

const growDown = keyframes`
  0% {
    height:0px;
  }
  100% {
    height: 140px;
  }
`;

const ContentArea = styled.div`
  width: 100%;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  animation: ${growDown} 300ms ease-in-out;
  overflow: hidden;
`;
